import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  MsalAuthenticationService, PagingService, LoginBaseComponent, SharedSettingsService
} from 'wtw-ui-components';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends LoginBaseComponent {

  constructor(
    route: ActivatedRoute,
    router: Router,
    public msalService: MsalAuthenticationService,
    metaTag: Meta,
    public sharedSettingsService: SharedSettingsService,
    pagingService: PagingService) {
    super(route, router, msalService, metaTag, sharedSettingsService, pagingService);
  }

}
